import React from 'react';
import { KurbanReportUIProvider } from './KurbanReportUIContext';
import { Route, useHistory } from 'react-router-dom';
import KurbanReportCard from './KurbanReportCard';

import KurbanReportEditDialog from './kurban-report-edit-dialog/KurbanReportEditDialog';
// import { PrivateRoute } from "../../../../PrivateRoute";
import { PrivateRoute } from "../../../../../PrivateRoute";
import { RoleChecker } from '../../../../../RoleChecker';

export function KurbanReportPage({ history }) {
    const History = useHistory()

    const kurbanReportUIEvents = {
        newKurbanReportButtonClick: () => {
            History.push({
                pathname: '/kurban/report/new',
                state: {
                    from: History.location.pathname + History.location.search
                }
            })
        },
        openEditKurbanReportPage: (id) => {
            History.push({
                pathname: `/kurban/report/${id}/detail`,
                state: {
                    from: History.location.pathname + History.location.search
                }
            })
        },
    };

    return (
        <KurbanReportUIProvider kurbanReportUIEvents={kurbanReportUIEvents}>
            <KurbanReportCard />
        </KurbanReportUIProvider>
    );
}
